import {Box, Typography} from '@mui/material';
import {useGetAlltimeTrackerEntities} from 'hooks';
import React from 'react';
import TimeTrackerCounter from './TimeTrackerCounter';
import TimeTrackerHistory from './TimeTrackerHistory';
import TimeTrackerItemSelect from './TimeTrackerItemSelect';
import TimeTrackerStartAndStopButton from './TimeTrackerStartAndStopButton';

interface TimeTrackerDarwaerContentProps {
    handleCloseAddUpdateDialog: () => void;
    openAddUpdateDialog: boolean;
    handleOpenAddUpdateDialog: () => void;
}
export const TimeTrackerDarwaerContent: React.FC<TimeTrackerDarwaerContentProps> = ({
    handleCloseAddUpdateDialog,
    openAddUpdateDialog,
    handleOpenAddUpdateDialog,
}) => {
    const {
        getAllTimeTrackerEntities,
        getAllTimeTrackerEntitiesResponse,
        getAllTimeTrackerEntitiesLoading,
        afterCreateUpdateHandler,
    } = useGetAlltimeTrackerEntities();
    return (
        <>
            <Box display="flex" gap={1}>
                <Box>
                    <TimeTrackerCounter />
                </Box>
                <Box>
                    <TimeTrackerStartAndStopButton title={''} afterCreateUpdateHandler={afterCreateUpdateHandler} />
                </Box>
            </Box>
            <TimeTrackerItemSelect afterCreateUpdateHandler={afterCreateUpdateHandler} />
            <Box mt={2} mb={1}>
                <Typography variant="h5">Recent History</Typography>
            </Box>
            <TimeTrackerHistory
                handleCloseAddUpdateDialog={handleCloseAddUpdateDialog}
                openAddUpdateDialog={openAddUpdateDialog}
                getAllTimeTrackerEntities={value => {
                    getAllTimeTrackerEntities({
                        variables: value,
                    });
                }}
                handleOpenAddUpdateDialog={handleOpenAddUpdateDialog}
                getAllTimeTrackerEntitiesResponse={getAllTimeTrackerEntitiesResponse}
                getAllTimeTrackerEntitiesLoading={getAllTimeTrackerEntitiesLoading}
                afterCreateUpdateHandler={afterCreateUpdateHandler}
            />
        </>
    );
};

export default TimeTrackerDarwaerContent;
